import { Autocomplete, TextField } from "@mui/material";
import * as React from "react";

import { Button } from "@/shared/foundation/primitives";

import styles from "./ChatFilters.module.css";

export interface FilterOption {
  label: string;
  id: string;
}

export interface ChatFiltersValues {
  org: FilterOption | null;
  user: FilterOption | null;
  sessionId: string;
}

interface ChatFiltersProps {
  values: ChatFiltersValues;
  onChange: (values: ChatFiltersValues) => void;
  onSearch: () => void;
  onClear: () => void;
  isLoading: boolean;
  orgOptions: FilterOption[];
  userOptions: FilterOption[];
  orgOptionsLoading: boolean;
  userOptionsLoading: boolean;
}

export function ChatFilters({
  values,
  onChange,
  onSearch,
  onClear,
  isLoading,
  orgOptions,
  userOptions,
  orgOptionsLoading,
  userOptionsLoading,
}: ChatFiltersProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  return (
    <div className={styles.filtersContainer}>
      <Autocomplete
        className={styles.filterInput}
        options={orgOptions}
        loading={orgOptionsLoading}
        value={values.org}
        onChange={(_e, newValue) => onChange({ ...values, org: newValue })}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Organization"
            size="small"
            placeholder="Search by name or ID..."
            onKeyDown={handleKeyDown}
          />
        )}
        renderOption={(props, option) => (
          <li key={option.id} {...props}>
            <span className={styles.optionLabel}>{option.label}</span>
          </li>
        )}
      />
      <Autocomplete
        className={styles.filterInput}
        options={userOptions}
        loading={userOptionsLoading}
        value={values.user}
        onChange={(_e, newValue) => onChange({ ...values, user: newValue })}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        renderInput={(params) => (
          <TextField
            {...params}
            label="User"
            size="small"
            placeholder="Search by name or email..."
            onKeyDown={handleKeyDown}
          />
        )}
        renderOption={(props, option) => (
          <li key={option.id} {...props}>
            <span className={styles.optionLabel}>{option.label}</span>
          </li>
        )}
      />
      <TextField
        className={styles.filterInput}
        label="Session ID"
        size="small"
        value={values.sessionId}
        onChange={(e) => onChange({ ...values, sessionId: e.target.value })}
        onKeyDown={handleKeyDown}
        placeholder="Session ID..."
      />
      <div className={styles.filterActions}>
        <Button
          variant="contained"
          size="small"
          onClick={onSearch}
          disabled={isLoading}
        >
          Search
        </Button>
        <Button variant="outlined" size="small" onClick={onClear}>
          Clear
        </Button>
      </div>
    </div>
  );
}
